<template>
  <div class="overflow: auto">
    <div style="display: flex; flex-wrap: wrap; margin-top: 10px">
      <div class="search_list">
        <div class="text">结算状态:</div>
        <Select v-model="state" class="select">
          <Option v-for="item in ProductData" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">订单状态:</div>
        <Select v-model="applyStatus" class="select">
          <Option value="0">订单初始化</Option>
          <Option value="1">初审失败</Option>
          <Option value="2">初审通过</Option>
          <Option value="3">激活成功</Option>
          <Option value="4">已首刷</Option>
          <Option value="5">终审失败</Option>
          <Option value="6">终审成功</Option>
          <Option value="7">已进件</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">代理查询:</div>
        <Input v-model="userName" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">订单号:</div>
        <Input v-model="orderId" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">渠道编码:</div>
        <Input v-model="t3rdCode" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">团队名称:</div>
        <Input v-model="groupName" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">产品名称:</div>
        <Input v-model="productName" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">用户姓名:</div>
        <Input v-model="name" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">用户手机号:</div>
        <Input v-model="phone" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">身份证号:</div>
        <Input v-model="pinCodes" search class="select" />
      </div>

      <div class="search_list">
        <div class="text">时间查询:</div>
        <DatePicker
          v-model="value2"
          style="width: 300px"
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime"
        ></DatePicker>
      </div>
      <div class="search_list">
        <div
          @click="changeInput()"
          style="
            color: #fff;
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
            width: 90px;
            text-align: center;
            display: inline-table;
          "
        >{{search}}</div>
        <a
          style="
            color: #fff;
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
            width: 50px;
            display: inline-table;
          "
          :href="url"
        >导出</a>
      </div>
    </div>
    <Table style="margin-top: 25px" :content="self" border stripe :columns="columns1" :data="data1">
      <template slot="applyStatus" slot-scope="{ row, index }">
        <div v-if="row.applyStatus == 0">订单初始化</div>
        <div v-if="row.applyStatus == 1">初审失败</div>
        <div v-if="row.applyStatus == 2">初审通过</div>
        <div v-if="row.applyStatus == 3">激活成功</div>
        <div v-if="row.applyStatus == 4">已首刷</div>
        <div v-if="row.applyStatus == 5">终审失败</div>
        <div v-if="row.applyStatus == 6">终审成功</div>
        <div v-if="row.applyStatus == 7">已进件</div>
      </template>
      <template slot="isNewUser" slot-scope="{ row, index }">
        <div v-if="row.isNewUser == 0">未更新</div>
        <div v-if="row.isNewUser == 1">是</div>
        <div v-if="row.isNewUser == 2">否</div>
      </template>
      <template slot="status" slot-scope="{ row, index }">
        <div v-if="row.state == 1">待确认</div>
        <div v-if="row.state == 2">已结算</div>
        <div v-if="row.state == 3">结算额外佣金</div>
        <div v-if="row.state == 4">已作废</div>
        <div v-if="row.state == 5">已通过</div>
      </template>
      <template slot="applyUrl" slot-scope="{ row, index }">
        <div style="height: 65px">{{ row.applyUrl }}</div>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 1 || row.state == 5"
          size="small"
          @click="
            modal3 = true;
            dataIndex = index;
          "
        >结算</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 4"
          size="small"
          @click="
            modal2 = true;
            dataIndex = index;
          "
        >取消作废</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="
            (row.state == 1 || row.state == 5) && row.productDemotedAmount != 0
          "
          size="small"
          @click="
            modal4 = true;
            dataIndex = index;
          "
        >降级结算</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 2"
          size="small"
          @click="
            modal5 = true;
            dataIndex = index;
          "
        >取消结算</Button>
        <Button
          style="
            background: #43a047;
            border-color: #43a047;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 1"
          size="small"
          @click="
            modal7 = true;
            dataIndex = index;
          "
        >已通过</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 2 && row.productExtraAmount != 0"
          size="small"
          @click="
            modal6 = true;
            dataIndex = index;
          "
        >额外佣金</Button>
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          v-if="row.state == 5"
          size="small"
          @click="
            modal8 = true;
            dataIndex = index;
          "
        >撤销已通过</Button>
        <Button
          style="
            background: #898989;
            border-color: #898989;
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="info"
          v-if="row.state == 1 || row.state == 5"
          size="small"
          @click="
            modal1 = true;
            dataIndex = index;
          "
        >作废</Button>
        <!-- <Button
          style="
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          v-if="
            row.productId == 42 || row.productId == 43 || row.productId == 44
          "
          type="info"
          size="small"
          @click="CebApiQuery(row.orderId)"
          >api查询</Button
        >-->
        <Button
          v-if="row.isOutside == 1"
          style="
            margin-left: 10px;
            float: right;
            background: #898989;
            border-color: #898989;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="info"
          size="small"
        >已确认</Button>
        <Button
          v-if="row.isOutside == 0"
          style="
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="info"
          size="small"
          @click="
            upData = row;
            active = 100000;
            active1 = 100000;
            product = { commission: '' };
            groupId = '';
            affirmShow = true;
            ProductQueryList = [];
          "
        >确认</Button>
        <Button
          style="
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          @click="
            upData = row;
            aaaa = true;
          "
          type="info"
          size="small"
        >订单状态</Button>
        <Button
          style="
            margin-left: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          @click="
            upData = row;
            isNewUser = true;
          "
          type="info"
          size="small"
          v-if="row.isNewUser == 0"
        >二卡初审</Button>
      </template>
    </Table>
    <br />
    <Modal v-model="isNewUser" title="二卡初审" @on-ok="NewUser()">
      <div style="width: 100%; text-align: center">二卡初审</div>
    </Modal>
    <Modal v-model="modal1" title="作废" @on-ok="cancellation(data1[dataIndex])">
      <div style="width: 100%; text-align: center">作废</div>
    </Modal>
    <Modal v-model="modal7" title="添加至已通过" @on-ok="PassedRewardAmount(data1[dataIndex])">
      <div style="width: 100%; text-align: center">添加至已通过</div>
    </Modal>
    <Modal v-model="modal2" title="取消作废" @on-ok="rollback(data1[dataIndex])">
      <div style="width: 100%; text-align: center">取消作废</div>
    </Modal>
    <Modal v-model="modal3" title="结算订单佣金" @on-ok="finish1(data1[dataIndex])">
      <div style="width: 100%; text-align: center">结算订单佣金</div>
    </Modal>

    <Modal v-model="modal4" title="结算订单降级佣金" @on-ok="finish2(data1[dataIndex])">
      <div style="width: 100%; text-align: center">结算订单降级佣金</div>
    </Modal>

    <Modal v-model="modal5" title="取消结算订单佣金" @on-ok="finish3(data1[dataIndex])">
      <div style="width: 100%; text-align: center">取消结算订单佣金</div>
    </Modal>

    <Modal v-model="modal6" title="结算订单额外佣金" @on-ok="finish4(data1[dataIndex])">
      <div style="width: 100%; text-align: center">结算订单额外佣金</div>
    </Modal>
    <Modal v-model="affirmShow" title="确认" width="600" @on-ok="affirm()">
      <div style="padding-bottom: 30px; border-bottom: 1px solid #ccc">
        <div
          style="
            font-size: 15px;
            font-weight: 900;
            color: #000;
            text-align: center;
          "
        >报单渠道</div>
        <div style="display: flex; flex-wrap: wrap">
          <div
            style="
              border: 1px solid;
              padding: 4px 18px;
              border-radius: 5px;
              margin-right: 15px;
              margin-top: 15px;
              width: 125px;
              text-align: center;
            "
            v-for="(data, index) in queryList"
            :key="index"
            :class="{ active: active == index }"
            @click="
              active = index;
              groupId = data.id;
              active1 = 100000;
              product.commission = 0;
              OutsideProductQueryList(data.id);
            "
          >{{ data.name }}</div>
        </div>
      </div>
      <div style="margin-top: 15px">
        <div
          style="
            font-size: 15px;
            font-weight: 900;
            color: #000;
            margin-top: 0.3rem;
            text-align: center;
          "
        >选择银行</div>
        <div style="display: flex; flex-wrap: wrap">
          <div
            style="
              border: 1px solid;
              padding: 4px 18px;
              border-radius: 5px;
              margin-right: 15px;
              margin-top: 15px;
              width: 125px;
              text-align: center;
            "
            v-for="(data, index) in ProductQueryList"
            :key="index"
            :class="{ active: active1 == index }"
            @click="
              active1 = index;
              product = data;
            "
          >{{ data.name }}</div>
        </div>
        <div
          style="text-align: center; font-size: 40px; color: red"
        >{{ (product.commission / 100).toFixed(2) }}</div>
      </div>
    </Modal>

    <Modal v-model="aaaa" title="状态" @on-ok="EditApplyStatus()">
      <div style="display: flex; align-items: center">
        <div style="width: 150px" class="text">选择状态:</div>
        <Select v-model="upData.applyStatus" class="select">
          <Option value="2">初审通过</Option>
          <Option value="3">激活成功</Option>
          <Option value="4">已首刷</Option>
          <Option value="6">终审成功</Option>
        </Select>
      </div>
    </Modal>
    <Modal v-model="modal8" title="撤销至待确认" @on-ok="cancelPassedRewardAmount(data1[dataIndex])">
      <div style="width: 100%; text-align: center">撤销至待确认</div>
    </Modal>
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "ProductOrder",

  data() {
    return {
      value2: [new Date(new Date().getTime() - 7879680000), new Date()],
      active: 100000,
      adasdas: "",
      product: { commission: "" },
      groupId: "",
      active1: 100000,
      queryList: [],
      upData: {},
      ProductQueryList: [],
      affirmShow: false,
      total: 0,
      url: this.url,
      applyStatus: null,
      isNewUser: false,
      modal1: false,
      modal7: false,
      modal2: false,
      orderId: null,
      modal3: false,
      modal4: false,
      groupName: null,
      modal5: false,
      t3rdCode: null,
      search: "搜索",
      aaaa: false,
      modal8: false,
      modal6: false,
      name: null,
      dataIndex: 0,
      time: [
        new Date(new Date().getTime() - 7879680000).getTime(),
        new Date().getTime() + 86400000
      ],
      phone: null,
      userName: null,
      pinCodes: null,
      self: this,
      state: null,
      keyword: null,
      productName: "",
      pageNow: 1,
      ProductData: [
        {
          value: "1",
          label: "待确认"
        },
        {
          value: "2",
          label: "已结算"
        },
        {
          value: "3",
          label: "结算额外佣金"
        },
        {
          value: "4",
          label: "已作废"
        },
        {
          value: "5",
          label: "已通过"
        }
      ],

      columns1: [
        {
          title: "渠道编码",
          align: "left",
          key: "t3rdCode",
          width: 150
        },

        {
          title: "代理人",
          align: "left",
          key: "username",
          width: 150
        },
        {
          title: "代理手机号",
          align: "left",
          key: "agentPhone",
          width: 150
        },

        {
          title: "团队名称",
          align: "left",
          key: "groupName",
          width: 150
        },
        {
          title: "用户姓名",
          align: "center",
          key: "name",
          width: 150
        },
        {
          title: "用户身份证",
          align: "center",
          key: "pincodes",
          width: 200
        },
        {
          title: "用户手机号",
          align: "center",
          key: "phone",
          width: 150
        },
        {
          title: "结算状态",
          align: "center",
          slot: "status",
          width: 150
        },
        {
          title: "订单状态",
          align: "center",
          slot: "applyStatus",
          width: 150
        },
        {
          title: "是否新用户",
          align: "left",
          slot: "isNewUser",
          width: 170
        },
        {
          title: "产品名称",
          align: "left",
          key: "productName",
          width: 170
        },
        {
          title: "创建时间",
          align: "center",
          key: "creationTime",
          width: 200
        },
        {
          title: "下达时间",
          align: "center",
          key: "arriveTime",
          width: 200
        },
        {
          title: "状态更新时间",
          align: "center",
          key: "statusUpdateTime",
          width: 200
        },
        {
          title: "奖励金额",
          align: "left",
          key: "productRewardAmount",
          width: 100
        },
        {
          title: "降级金额",
          align: "left",
          key: "productDemotedAmount",
          width: 100
        },
        {
          title: "额外金额",
          align: "left",
          key: "productExtraAmount",
          width: 100
        },

        {
          title: "订单号",
          align: "left",
          key: "orderId",
          width: 200
        },
        {
          title: "进件地址",
          align: "left",
          slot: "applyUrl",
          width: 800
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action",
          width: 550,
          fixed: "right"
        }
      ],
      data1: []
    };
  },

  activated: function() {
    this.getData("");
  },
  mounted: function() {
    this.getData("");
  },
  methods: {
    EditApplyStatus() {
      api.EditApplyStatus(this.upData.id, this.upData.applyStatus).then(res => {
        if (res.body.status) {
          this.$Message.info(res.body.message);
        }
        this.getData();
      });
    },
    NewUser() {
      api.InformationIsOld(this.upData.id).then(res => {
        if (res.body.status) {
          this.$Message.info(res.body.message);
        }
        this.getData();
      });
    },
    affirm() {
      api
        .AddOutsideOrder({
          informationId: this.upData.id,
          groupId: this.groupId,
          productId: this.product.id
        })
        .then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
    },
    OutsideProductQueryList(id) {
      api
        .OutsideProductQueryList({
          pageNow: 1,
          pageSize: 99999,
          groupId: id
        })
        .then(res => {
          this.ProductQueryList = res.body.data.list;
        });
    },
    CebApiQuery(id) {
      api.CebApiQuery(id).then(res => {
        if (res.body.status == 1) {
          alert(res.body.data);
        }
      });
    },
    getData() {
      api
        .OutsideGroupQueryList({
          pageNow: 1,
          pageSize: 99999
        })
        .then(res => {
          this.queryList = res.body.data.list;
        });
      let name;
      if (this.name) {
        name = this.name.replace(/\*/g, "_");
      }
      let phone;
      if (this.phone) {
        phone = this.phone.replace(/\*/g, "_");
      }

      api
        .GetAllUserProductInformation({
          pageNow: this.pageNow,
          pageSize: "10",
          name,
          applyStatus: this.applyStatus,
          groupName: this.groupName,
          state: this.state,
          userName: this.userName,
          rootId: this.$route.query.id,
          pinCodes: this.pinCodes,
          orderId: this.orderId,
          phone,
          t3rdCode: this.t3rdCode,
          start: this.time[0],
          end: this.time[1],
          productName: this.productName
        })
        .then(res => {
          this.search = "搜索";
          if (res.body.data) {
            this.total = res.body.data.total;
            this.data1 = res.body.data.list;
            this.data1.forEach(element => {
              element.productRewardAmount = element.productRewardAmount / 100;
              element.productDemotedAmount = element.productDemotedAmount / 100;
              element.productExtraAmount = element.productExtraAmount / 100;
            });
          } else {
            this.total = 0;
            this.data1 = [];
          }
        });
      var productName = "";
      if (this.productName) {
        productName = encodeURIComponent(this.productName);
      } else {
        productName = "";
      }

      var parameter = `name=${this.name ? this.name : ""}&state=${
        this.state ? this.state : ""
      }&userName=${this.userName ? this.userName : ""}&pinCodes=${
        this.pinCodes ? this.pinCodes : ""
      }&phone=${this.phone ? this.phone : ""}&start=${
        this.time[0] ? this.time[0] : ""
      }&end=${this.time[1] ? this.time[1] : ""}&productName=${
        productName ? productName : ""
      }&groupName=${this.groupName ? this.groupName : ""}&applyStatus=${
        this.applyStatus ? this.applyStatus : ""
      }&t3rdCode=${this.t3rdCode ? this.t3rdCode : ""}&orderId=${
        this.orderId ? this.orderId : ""
      }`;

      this.url = `/api/v1/information/getInformationToExcel?${parameter}`;
    },
    changeInput() {
      this.pageNow = 1;
      if (this.search == "搜索") {
        this.search = "搜索中...";
        this.getData();
      }
    },

    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.$forceUpdate();
      // this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    },
    PassedRewardAmount(res) {
      api
        .PassedRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    cancelPassedRewardAmount(res) {
      api
        .CancelPassedRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    cancellation(res) {
      api
        .DelRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    rollback(res) {
      api
        .CancelDelRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    finish1(res) {
      api
        .SettlementRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    finish2(res) {
      api
        .SettlementDemotedAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    finish3(res) {
      api
        .CancelSettlementRewardAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    },
    finish4(res) {
      api
        .SettlementExtraAmount({
          informationId: res.id
        })
        .then(res => {
          this.getData();
        });
    }
  }
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.active {
  background: #1d89e4;
  color: #fff;
}
</style>